<br><br><br>
<main class="wrap">
  <section class="ask-isalni" aria-label="Ask Isalni section">

    <!-- LEFT: Question form -->
    <div class="ask-form" aria-label="Question form">
      
      <h2>{{ 'isalni.title' | translate }}</h2>
      <p class="form-subtitle">
        {{ 'isalni.subtitle' | translate }}
      </p>
      
      <textarea
        [(ngModel)]="question"
        [placeholder]="'isalni.placeholder' | translate"
        rows="6"
        class="question-input"
      ></textarea>
      
      <button 
        (click)="submitQuestion()" 
        class="submit-button" 
        [disabled]="isLoading"
      >
        <span>{{ 'isalni.sendQuestion' | translate }}</span>
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
      </button>

      <!-- Loading -->
      <div *ngIf="isLoading" class="loading-indicator">
        <div class="spinner"></div>
        <p>{{ 'isalni.loadingResponse' | translate }}</p>
      </div>
        
      <!-- Response -->
      <div *ngIf="response && !isLoading" class="response-area">
        <h3>{{ 'isalni.response' | translate }}</h3>
        <p>{{ response }}</p>
      </div>

    </div>

    <!-- RIGHT: Illustration cards -->
    <aside class="illustration-cards" aria-label="Isalni features">

      <!-- Card 1 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
          </svg>
        </div>
        <h3>{{ 'isalni.card1Title' | translate }}</h3>
        <p>{{ 'isalni.card1Desc' | translate }}</p>
      </article>

      <!-- Card 2 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M21 6h-2v2h-2V6h-2V4h2V2h2v2h2v2zm-10 3c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0 4c-2.33 0-7 1.17-7 3.5V17h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
        </div>
        <h3>{{ 'isalni.card2Title' | translate }}</h3>
        <p>{{ 'isalni.card2Desc' | translate }}</p>
      </article>

      <!-- Card 3 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.1.8-1.2-4.5-2.7V7z"/>
          </svg>
        </div>
        <h3>{{ 'isalni.card3Title' | translate }}</h3>
        <p>{{ 'isalni.card3Desc' | translate }}</p>
      </article>

      <!-- Card 4 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 3l9 4.5-9 4.5L3 7.5 12 3zm0 7.236l6-3v3.764L12 14l-6-2.999V7.236l6 3zM5 15.5L12 18l7-2.5V21H5v-5.5z"/>
          </svg>
        </div>
        <h3>{{ 'isalni.card4Title' | translate }}</h3>
        <p>{{ 'isalni.card4Desc' | translate }}</p>
      </article>

    </aside>
  </section>
</main>

<div class="float-blob" aria-hidden="true"></div>

<style>
  :root {
    --brand-teal: #2fb2b6;
    --brand-teal-dark: #1a8f93;
    --gradient-start: #cdeee9;
    --gradient-end: #e9f6e2;
    --text: #222;
    --muted: #6b7280;
    --card: #ffffff;
    --shadow: 0 8px 24px rgba(0,0,0,.12);
    --shadow-soft: 0 10px 30px rgba(0,0,0,.08);
    --radius: 14px;
  }

  * {
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
  }

  body {
    margin: 0;
    font-family: "Poppins", system-ui, -apple-system, 'Segoe UI', Roboto, Arial, Helvetica, sans-serif;
    color: var(--text);
    background: #fff;
    min-height: 100vh;
    position: relative;
  }

  /* Header (optional - à utiliser si besoin) */
  .header {
    background: linear-gradient(90deg, var(--gradient-start), var(--gradient-end));
    padding: 14px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0,0,0,.04);
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .logo {
    width: 150px;
    height: 30px;
    background: linear-gradient(90deg, #43c5c8, #9be2d5);
    border-radius: 6px;
    position: relative;
    box-shadow: inset 0 0 0 2px rgba(255,255,255,.85);
  }

  .logo:after {
    content: "EDUCANET";
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: .12em;
    color: #0e7f83;
  }

  .nav {
    display: flex;
    gap: 28px;
    align-items: center;
    font-weight: 500;
  }

  .nav a {
    text-decoration: none;
    color: #2b5658;
    transition: color 0.2s ease;
  }

  .nav a:hover {
    color: #0f7f83;
  }

  .profile {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #e7f7f4;
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid rgba(0,0,0,.05);
  }

  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #c4edea;
    border: 2px solid #fff;
  }

  .name {
    font-size: 14px;
    color: #0e7f83;
    font-weight: 600;
  }

  /* PAGE LAYOUT */
  .wrap {
    max-width: 1320px;
    margin: 48px auto;
    padding: 0 24px;
    position: relative;
    z-index: 2;
  }

  .ask-isalni {
    display: flex;
    gap: 36px;
    align-items: flex-start;
  }

  /* LEFT: Formulaire */
  .ask-form {
    flex: 1;
    background: var(--card);
    border-radius: var(--radius);
    padding: 30px;
    box-shadow: var(--shadow);
    border: 1px solid rgba(47,178,182,.35);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .ask-form:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 28px rgba(0,0,0,.16);
    border-color: rgba(47,178,182,.55);
  }

  .ask-form h2 {
    margin: 0 0 8px 0;
    font-size: 28px;
    font-weight: 600;
    color: var(--brand-teal-dark);
    letter-spacing: 1px;
  }

  .form-subtitle {
    margin: 0 0 25px 0;
    font-size: 16px;
    color: var(--muted);
  }

  .question-input {
    width: 100%;
    padding: 18px;
    border-radius: 12px;
    border: 2px solid rgba(47,178,182,.2);
    outline: none;
    resize: none;
    font-size: 15px;
    margin-bottom: 25px;
    background: #f8fdfc;
    color: var(--text);
    font-family: inherit;
    transition: all 0.3s ease;
  }

  .question-input::placeholder {
    color: #9ca3af;
  }

  .question-input:focus {
    border-color: var(--brand-teal);
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(47,178,182,.1);
  }

  .submit-button {
    padding: 14px 28px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    background: #000000; /* Noir */
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0,0,0,.3);
  }

  .submit-button:hover {
    background: #333333; /* Gris foncé au survol */
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0,0,0,.4);
  }

  .button-text {
    color: white;
    font-weight: 600;
  }

  .submit-button svg {
    fill: white;
    width: 18px;
    height: 18px;
  }

  .response-area {
    margin-top: 30px;
    padding: 20px;
    border-radius: 12px;
    background: rgba(47,178,182,.08);
    border-left: 4px solid var(--brand-teal);
    text-align: left;
    animation: fadeIn 0.4s ease-in-out;
  }

  .response-area h3 {
    margin: 0 0 12px 0;
    font-size: 18px;
    color: var(--brand-teal-dark);
    font-weight: 600;
  }

  .response-area p {
    margin: 0;
    font-size: 15px;
    line-height: 1.6;
    color: #374151;
  }

  /* RIGHT: Cards 2x2 */
  .illustration-cards {
    display: grid;
    gap: 28px;
    grid-template-columns: repeat(2, 220px);
    align-content: start;
    flex-shrink: 0;
  }

  .card {
    background: var(--card);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    border: 1px solid rgba(47,178,182,.35);
    padding: 22px 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    text-align: center;
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
    min-height: 200px;
  }

  .card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(0,0,0,.16);
    border-color: rgba(47,178,182,.55);
  }

  .icon {
    width: 70px;
    height: 70px;
    border-radius: 18px;
    background: rgba(47,178,182,.12);
    display: grid;
    place-items: center;
    margin-bottom: 4px;
  }

  .icon svg {
    width: 38px;
    height: 38px;
    fill: var(--brand-teal);
  }

  .card h3 {
    margin: 4px 0 0;
    font-size: 17px;
    font-weight: 700;
    color: var(--brand-teal-dark);
  }

  .card p {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
    color: #4b5563;
  }

  /* Animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Decorative blob */
  .float-blob {
    content: "";
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(closest-side, rgba(47,178,182,.08), transparent 70%);
    position: fixed;
    right: -40px;
    bottom: -40px;
    pointer-events: none;
    filter: blur(1px);
    z-index: 1;
  }

  /* RESPONSIVE */
  @media (max-width: 1200px) {
    .ask-isalni {
      flex-direction: column;
    }
    
    .illustration-cards {
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
    }
    
    .card {
      min-height: 180px;
    }
  }

  @media (max-width: 620px) {
    .wrap {
      padding: 0 16px;
      margin: 30px auto;
    }
    
    .ask-form {
      padding: 20px;
    }
    
    .illustration-cards {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .card {
      min-height: auto;
    }
    
    .ask-form h2 {
      font-size: 24px;
    }
    
    .submit-button {
      width: 100%;
      justify-content: center;
    }
  }
</style>